import React, { createContext, useContext, useEffect } from "react";

interface ThemeContextValue {
	theme: "dark";
}

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
	useEffect(() => {
		// Always apply dark mode class
		const root = document.documentElement;
		root.classList.add("dark");
	}, []);

	return (
		<ThemeContext.Provider value={{ theme: "dark" }}>
			{children}
		</ThemeContext.Provider>
	);
};

export const useTheme = () => {
	const ctx = useContext(ThemeContext);
	if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
	return ctx;
};

export default ThemeProvider;
